/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import slugify from 'slugify';

import { Input } from '@atoms';
import { Form } from '@organisms';

const SlugField = ({ placeholder = 'oregon-21', generateSlugFrom, onChange, ...props }) => {
  const [dirty, setDirty] = React.useState(false);

  const handleOnChange = React.useCallback(
    (event) => {
      setDirty(true);
      // eslint-disable-next-line no-unused-expressions
      onChange?.(event);
    },
    [onChange],
  );

  return (
    <>
      <Form.WithFieldValue name={generateSlugFrom}>
        {(value, form) => {
          if (!value || !generateSlugFrom || dirty) return;

          form.setFieldsValue({ [props.name]: slugify(value || '', { strict: true, lower: true }) });
        }}
      </Form.WithFieldValue>
      <Form.Item onChange={handleOnChange} {...props}>
        <Input placeholder={placeholder} />
      </Form.Item>
    </>
  );
};

export default SlugField;
